import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { brand, faqs } from "@/mocks/site";

export default function FaqPage() {
  useSeo({
    title: "常见问题 - 黑暗爆料的定位、边界与使用方式",
    description:
      "关于黑暗爆料的常见问题：内容是否真实、为何不点名具体公司、如何提供线索、更新频率、避坑要点能否作为法律依据、平台是否收费等，一次说清。",
    keywords: "黑暗爆料,常见问题,内容原则,线索征集,更新频率,避坑要点",
    path: "/faq",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "首页",
            item: "https://i2785.cn/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "常见问题",
            item: "https://i2785.cn/faq",
          },
        ],
      },
    ],
  });

  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <section className="bg-background-100 border-b border-background-200">
          <div className="max-w-[1240px] mx-auto px-4 md:px-10 py-10 md:py-14">
            <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
            <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-4xl">
              你想问的，大概都在这里
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
              关于内容来源、写作边界、线索处理和使用方式的七个问题。如果还有疑问，欢迎直接发邮件给我们。
            </p>
          </div>
        </section>

        <section className="max-w-[1240px] mx-auto px-4 md:px-10 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-8">
              <FaqAccordion items={faqs} defaultOpenId={faqs[0]?.id} />
            </div>

            <aside className="lg:col-span-4 space-y-5">
              <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl mb-4">
                  <i className="ri-mail-send-line" aria-hidden="true"></i>
                </span>
                <h2 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  还有别的问题
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  把你遇到的场景写清楚发过来，我们会尽量在后续档案里回应。
                </p>
                <Link
                  to="/about#submit"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800"
                >
                  前往投稿与联系
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <h2 className="font-heading text-base font-semibold text-foreground-950 mb-4">
                  从这里开始读
                </h2>
                <ul className="space-y-3">
                  <li>
                    <Link
                      to="/cases?category=consumer"
                      className="flex items-center justify-between text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      消费陷阱
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cases?category=industry"
                      className="flex items-center justify-between text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      行业潜规则
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cases?category=career"
                      className="flex items-center justify-between text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      职场招聘
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5 md:p-6">
                <p className="text-xs text-secondary-800 mb-1">邮件联系</p>
                <p className="font-heading text-base text-foreground-950 break-all">{brand.email}</p>
              </div>
            </aside>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}